<template>
    <div>
        <v-hover
            v-slot="{ hover }"
        >
            <v-card 
                :elevation="hover ? 6 : 1"
                class="mx-auto custom-card" 
                outlined 
                style="background-color: white;"
                @click.prevent="setDialog('showitem',item)"
            >
                <v-card-text>
                    <v-row>
                        <v-col cols="12" md="12">
                            <v-row dense>
                                <v-col cols="12" sm="12" md="6">
                                    <span>
                                        <v-chip
                                            color="blue"
                                            label
                                            text-color="white"
                                            class="text-subtitle-1"
                                        >
                                        Cod: {{ item.codigo }} 
                                        </v-chip>   
                                    </span>
                                    <span class="ml-2">
                                        <v-chip
                                            :color="item.status | statusProposal"
                                            label
                                            text-color="black"
                                            class="text-text-subtitle-1"
                                        >
                                            {{ item.status }}
                                        </v-chip> 
                                    </span>
                                </v-col>   
                                <v-col cols="12" sm="12" md="6">
                                    <span class="text-right text-h7 black--text font-weight-medium">  
                                        DT CAD.: 
                                        <span v-if="item.created_at"> {{ item.created_at }}</span>
                                    </span>
                                    <span class="ml-2 text-right text-h7 black--text font-weight-medium">  
                                        DT AT.: 
                                        <span v-if="item.updated_at"> {{ item.updated_at }}</span>
                                    </span>
                                </v-col>     
                            </v-row>    

                            <v-row dense>
                                <v-col cols="12" sm="12" md="12">
                                    <v-divider></v-divider>
                                </v-col>        
                            </v-row>

                            <v-row dense>
                                <v-col cols="12" sm="12" md="12" class="text-subtitle-1 font-weight-light black--text">
                                    <v-chip
                                        color="black"
                                        outlined
                                        class="mr-2"
                                    >
                                    COD IMOVEL: {{ item.property.codigo }}
                                    </v-chip> 
                                    
                                    Endereço do imóvel: {{ item.endereco }}
                                    <span v-if="item.numero">, {{ item.numero }} </span>
                                    <span v-if="item.apartamento"> - Apto: {{ item.apartamento }} </span>
                                    <span v-if="item.complemento"> - Compl: {{ item.complemento }} </span>
                                    <span v-if="item.bairro">  - {{ item.bairro }} </span>
                                    <span v-if="item.cidade">  - {{ item.cidade }} </span>
                                    <span v-if="item.estado">  - {{ item.estado }} </span>
                                    <span v-if="item.cep">  - {{ item.cep | VMask('#####-###') }} </span>
                                </v-col>        
                            </v-row>

                            <v-row no-gutters dense>
                                <v-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                                    <div>
                                        <span v-if="item.valor_proposta && item.valor_proposta > 0" :class="$css_subtitle_2 + ' black--text text-subtitle-1'"> 
                                            <span v-if="item.setor" class="mr-2">Proposta de {{ item.setor }}: </span>
                                            {{ item.valor_proposta | toCurrency }}
                                            
                                        </span>

                                        <span v-if="item.comissao && item.comissao != 'null' && item.comissao > 0" class="ml-1 mr-2 black--text text-subtitle-1'">
                                            -  Comissão: {{ item.comissao }} %
                                        </span>
                                    </div>
                                </v-col>
                                <v-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                                    <span v-if="item.colaborators" :class="$css_subtitle_2 + ' black--text text-subtitle-1'">
                                        <div v-if="item.colaborators">
                                            Colaboradores: 
                                            <span v-for="colab in item.colaborators.slice(0, 1)" :key="colab.id">
                                                {{ colab.name }}
                                                <span v-if="item.colaborators.length > 1" class="mr-2">(+ {{ item.colaborators.length -1 }})</span>
                                            </span>
                                        </div>  
                                    </span>
                                </v-col>    
                            </v-row>

                            <v-row dense>
                                <v-col cols="12" xs="12" sm="12" md="9" lg="9" xl="9" :class="$css_subtitle_2 + ' black--text text-subtitle-1'">
                                    Proponente:
                                    <span v-if="item.residents && item.residents.length > 0">
                                        <span v-for="colab in item.residents.filter(c => c.principal === 'Sim').slice(0, 1)" :key="colab.id">
                                            <span v-if="colab.principal && colab.principal == 'Sim'">
                                                {{ colab.nome }}
                                            </span>
                                        </span>

                                        <span v-if="item.residents.length > 1" class="mr-2">(+ {{ item.residents.length -1 }})</span>
                                    </span>    
                                </v-col>
                                <v-col cols="12" xs="12" sm="12" md="3" lg="3" xl="3" class="text-right">
                                    <v-tooltip top>
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-btn  v-bind="attrs" v-on="on" :class="$css_button" depressed outlined @click.prevent="setDialog('showitem',item)">
                                                <v-icon left>mdi-camera</v-icon> Ficha
                                            </v-btn>
                                        </template>
                                        <span>Visualizar Ficha</span>
                                    </v-tooltip>
                                    <v-tooltip  top v-if="(me.profile == 'Master' || me.profile == 'Gerente') || (item.status === 'Nova' || item.status === 'Pendente')">
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-btn  class="ml-3"  v-bind="attrs" v-on="on" :class="$css_button" depressed outlined @click.prevent="editItem(item.id)">
                                                <v-icon left>mdi-pencil</v-icon> Editar
                                            </v-btn>
                                        </template>
                                        <span>Edita Ficha</span>
                                    </v-tooltip>
                                </v-col> 
                            </v-row>
  
                        </v-col>
                    </v-row>
                </v-card-text>    
            </v-card>
        </v-hover>    
    </div>
</template>

<script>

export default {
    components: {
    },

    computed: {
        me () {
          return this.$store.state.auth.me
        },
        tenant() {
            return this.$store.state.tenants.items.data    
        },
    }, 

    props: {
        item: {
            type: Object, // Adicione o tipo
            required: true, // Corrigido: "required" em vez de "require"
            default: () => {} // Adicione um valor padrão para arrays
        },
    },

    data () {
        return {
            
        }
    },

    methods: {
        setDialog(module, item){
            const params = {};
            params.module = module;
            params.item = item; 
            this.$emit('callSetDialog', params);
        },
        
        editItem(id){
            this.$router.push({
                name: 'admin.proposals.edit',
                params: { id: id }
            });
        }
    }
}
</script>